import { render, staticRenderFns } from "./activityDetail.vue?vue&type=template&id=7f40845d&scoped=true&"
import script from "./activityDetail.vue?vue&type=script&lang=js&"
export * from "./activityDetail.vue?vue&type=script&lang=js&"
import style0 from "./activityDetail.vue?vue&type=style&index=0&id=7f40845d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f40845d",
  null
  
)

export default component.exports